import React from 'react'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const BannerContainer = styled.div`
    background-color: #fffaf0;
    padding: 12px 20px;
    text-align: center;
    border-radius: 4px;
    margin-bottom: 15px;
`

const BannerLine = styled.div`
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
`

const BannerLink = styled.a`
    font-size: 14px;
    color: #333;
    text-decoration: underline;
    font-weight: bold;

    &:hover {
        color: #9B5B7E;
    }
`

export function KavickaBanner() {
    const {t} = useTranslation()
    return (
        <BannerContainer>
            <BannerLine>
                <strong>{t('kavicka_date_time')}</strong> - {t('kavicka_event_text')} <BannerLink href="https://amani.sk/kurzy-pri-kavicke" target="_blank" rel="noopener noreferrer">{t('kavicka_link_text')}</BannerLink>
            </BannerLine>
            <BannerLine>
                &bdquo;{t('kavicka_quote')}&ldquo; {t('kavicka_speaker')}
            </BannerLine>
        </BannerContainer>
    )
}
